import React from "react";
import { Button, Grid, Paper, Avatar, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { LOGIN } from "../../constants/routes";

const Landing = () => {
  return (
    <Box sx={{ height: "100vh" }}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <Grid
          item
          size={{xs:false, sm:5, md:6}}
          sx={{
            backgroundImage:
              "url(https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid
          item
          size={{xs:12, sm:7, md:6}}
          component={Paper}
          elevation={6}
          square
        >
          <Box
            sx={{
              margin: (theme) => theme.spacing(8, 4),
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar
              alt="Skillsminer"
              src="/images/logo_gray.png"
              sx={{ width: (theme) => theme.spacing(10), height: (theme) => theme.spacing(10) }}
              variant="square"
            />
            <Button color="primary" component={Link} to={LOGIN}>
              LOGIN
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Landing;